import React, { useMemo, useState, useEffect } from "react";
import { Input, Select, DatePicker, Badge } from "antd";
import {
	arrayToQueryParam,
	queryParamToArray,
	queryParamToArray2,
	queryParamToArrayForJobid,
	stageArray,
	DIGITIZER_STAGE_VALUE,
} from "components/CardListing/State";
import { useDispatch, useSelector } from "react-redux";
import {
	Client_filter,
	Client_filter_completed,
	Stage_filter,
	Jobid_filter,
	jobCard_page,
	jobCard_pageComplete,
	Created_by_filter,
	Date_filter,
	Jobid_filter_completed,
	Embridary_placement_front_filter_completed,
} from "features/auth/userSlice";
import { Embridary_placement_front_filter } from "features/auth/userSlice";
import { roleSelector } from "features/jobinv/JobCardSlice";
import { ROLES } from "components/common/Constants";
import { useFetchUsersQuery } from "features/store";
import { url } from "components/common/api";
import moment from "moment";

const MultidropDown = ({ client_company, c, cards, cardsCompleted }) => {
	const {
		client_filter,
		stage_filter,
		client_filter_completed,
		jobid_filter,
		jobid_filter_completed,
		embridary_placement_front_filter_completed,
		embridary_placement_front_filter,
		created_by,
		date,
	} = useSelector((state) => state.user);
	const role = useSelector(roleSelector);
	const [selectedItems, setSelectedItems] = useState(queryParamToArray(client_filter));
	const [stage, setStage] = useState(queryParamToArray2(stage_filter));
	const [completed, setCompleted] = useState(queryParamToArray(client_filter_completed));
	const [jobIds, setJobIds] = useState(queryParamToArrayForJobid(jobid_filter));
	const [jobIdsCompleted, setJobIdsCompleted] = useState(
		queryParamToArrayForJobid(jobid_filter_completed),
	);
	const [currentJobIdInput, setCurrentJobIdInput] = useState("");
	const [selectedCreatedBy, setSelectedCreatedBy] = useState(created_by || "");
	const [selectedDate, setSelectedDate] = useState(date ? moment(date, "YYYY-MM-DD") : null);
	const [selectedEmbridaryFront, setSelectedEmbridaryFront] = useState(
		embridary_placement_front_filter_completed || ""
	);
	const [selectedEmbridaryFrontUnder, setSelectedEmbridaryFrontUnder] = useState(
		embridary_placement_front_filter || ""
	);
	const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
	const [clientCompletedDropdownOpen, setClientCompletedDropdownOpen] = useState(false);
	const dispatch = useDispatch();
	const { data: users, isLoading: usersLoading } = useFetchUsersQuery({
		refetchOnMountOrArgChange: true,
	});
    

	const handleselect = (data) => {
		const queryString = arrayToQueryParam("client", data);
		dispatch(jobCard_page(1));
		dispatch(Client_filter(queryString));
		setSelectedItems(data);
		setClientDropdownOpen(false);
	};

	const handleselect_completed = (data) => {
		const queryString = arrayToQueryParam("client", data);
		dispatch(jobCard_pageComplete(1));
		dispatch(Client_filter_completed(queryString));
		setCompleted(data);
		setClientCompletedDropdownOpen(false);
	};

	const stageOptions = useMemo(() => {
		if (role === ROLES.ADMIN) {
			return [...stageArray, DIGITIZER_STAGE_VALUE];
		}
		return stageArray;
	}, [role]);

	const handleselect2 = (data) => {
		const hasDigitizerStage = data.includes(DIGITIZER_STAGE_VALUE);
		const normalizedStages = data.filter(
			(item) => item !== DIGITIZER_STAGE_VALUE,
		);
		const stageQuery =
			normalizedStages.length > 0
				? arrayToQueryParam("current_stage", normalizedStages)
				: "";
		const digitizerQuery = hasDigitizerStage ? "&is_degitizer_stage=true" : "";
		const queryString = `${stageQuery}${digitizerQuery}`;
		dispatch(jobCard_page(1));
		dispatch(Stage_filter(queryString));
		setStage(data);
	};

	const handleJobIdChange = (e) => {
		const value = e.target.value;
		setCurrentJobIdInput(value);

		if (value.endsWith(",")) {
			const id = value.slice(0, -1).trim();
			if (id) {
				// Accept both numeric (e.g., "123") and alphanumeric (e.g., "123A") serial numbers
				if (!jobIds.includes(id)) {
					const newJobIds = [...jobIds, id];
					setJobIds(newJobIds);
					dispatch(jobCard_page(1));
					dispatch(Jobid_filter(arrayToQueryParam("jobid", newJobIds)));
				}
			}
			setCurrentJobIdInput("");
		}
	};

	const handleJobIdBlur = () => {
		const trimmed = currentJobIdInput.trim();
		if (trimmed) {
			// Accept both numeric (e.g., "123") and alphanumeric (e.g., "123A") serial numbers
			if (!jobIds.includes(trimmed)) {
				const newJobIds = [...jobIds, trimmed];
				setJobIds(newJobIds);
				dispatch(jobCard_page(1));
				dispatch(Jobid_filter(arrayToQueryParam("jobid", newJobIds)));
			}
		}
		setCurrentJobIdInput("");
	};

	const handleCreatedByChange = (value) => {
		setSelectedCreatedBy(value);
		dispatch(jobCard_page(1));
		dispatch(Created_by_filter(value || ""));
	};

	const handleDateChange = (date, dateString) => {
		setSelectedDate(date);
		dispatch(jobCard_page(1));
		dispatch(Date_filter(dateString || ""));
	};

	// Check if any stage is selected
	const hasStageSelected = stage && stage.length > 0;
	const hasDigitizerSelected = stage && stage.includes(DIGITIZER_STAGE_VALUE);
	
	// Get count of digitizer jobcards
	// When digitizer stage is selected, the API filters by is_degitizer_stage=true
	// So cards?.count represents the total count of digitizer jobcards
	const digitizerCount = useMemo(() => {
		if (!hasDigitizerSelected || !cards) return 0;
		// Use the total count from API response when digitizer is selected
		// This is more accurate than counting from current page results
		return cards?.count || 0;
	}, [hasDigitizerSelected, cards?.count]);

	// Helper function to format stage labels
	const formatStageLabel = (stageName) => {
		const specialCases = {
			secendory_process: 'Sec_Process',
			embroidary: 'Embroidery',
			account: 'Billing',
			designer: 'Design',
			digitizer: 'Digitizer',
		};
		
		if (specialCases[stageName]) return specialCases[stageName];
		
		return stageName
			.split('_')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	// Get sort value (default to 'noncompleted')
	const sort_job = useSelector((state) => state.user.sort_job) || 'noncompleted';
	
	// Fetch individual stage counts when multiple stages are selected
	const selectedStages = stage || [];
	const isMultipleStages = selectedStages.length > 1;
	const [stageCountData, setStageCountData] = useState({});
	
	// Fetch individual stage counts when multiple stages are selected
	useEffect(() => {
		if (!isMultipleStages || !hasStageSelected) {
			setStageCountData({});
			return;
		}
		
		const fetchStageCounts = async () => {
			const counts = {};
			
			await Promise.all(
				selectedStages.map(async (stageName) => {
					try {
						let queryString = `/api/?page=1&page_size=1`;
						
						// Add other filters
						if (client_filter) queryString += client_filter;
						if (jobid_filter) queryString += jobid_filter;
						if (created_by) queryString += `&created_by=${created_by}`;
						if (date) queryString += `&date=${date}`;
						queryString += `&sort=${sort_job}`;
						
						// Add stage-specific filter
						if (stageName === DIGITIZER_STAGE_VALUE) {
							queryString += "&is_degitizer_stage=true";
						} else {
							queryString += arrayToQueryParam("current_stage", [stageName]);
						}
						
						const response = await fetch(`${url}${queryString}`, {
							method: "GET",
							headers: {
								"Content-Type": "application/json",
								Authorization: `Bearer ${localStorage.getItem("userToken")}`,
								Accept: "application/json",
							},
						});
						
						if (response.ok) {
							const data = await response.json();
							counts[stageName] = data?.count || 0;
						} else {
							counts[stageName] = 0;
						}
					} catch (error) {
						console.error(`Error fetching count for ${stageName}:`, error);
						counts[stageName] = 0;
					}
				})
			);
			
			setStageCountData(counts);
		};
		
		fetchStageCounts();
	}, [isMultipleStages, hasStageSelected, selectedStages, client_filter, jobid_filter, sort_job, created_by, date]);
	
	// Calculate counts only for selected stages
	const stageCounts = useMemo(() => {
		if (!hasStageSelected || !cards) return [];
		
		return selectedStages.map((stageName) => {
			let count = 0;
			
			if (stageName === DIGITIZER_STAGE_VALUE) {
				// For digitizer
				if (isMultipleStages) {
					// When multiple stages selected, use individual API call count
					count = stageCountData[stageName] || 0;
				} else {
					// When only digitizer selected, use cards?.count (more accurate from API)
					count = cards?.count || 0;
				}
			} else {
				// For other stages
				if (isMultipleStages) {
					// When multiple stages selected, use individual API call count
					count = stageCountData[stageName] || 0;
				} else {
					// When only one stage selected, use cards?.count (more accurate from API)
					count = cards?.count || 0;
				}
			}
			
			return {
				stage: stageName,
				label: formatStageLabel(stageName),
				count: count,
			};
		});
	}, [hasStageSelected, stage, cards, isMultipleStages, stageCountData]);

	if (c === "created_by_filter") {
		return (
			<Select
				placeholder="Select Created By"
				value={selectedCreatedBy || undefined}
				onChange={handleCreatedByChange}
				style={{
					width: "100%",
					margin: "0px 10px",
					height: "32px",
				}}
				allowClear
				loading={usersLoading}
				options={
					users
						? users?.map((user) => ({
								value: user.user,
								label: `${user.user}`,
						  }))
						: []
				}
			/>
		);
	} else if (c === "date_filter") {
		return (
			<DatePicker
				placeholder="Select Date"
				value={selectedDate}
				onChange={handleDateChange}
				format="YYYY-MM-DD"
				style={{
					width: "100%",
					margin: "0px 10px",
					height: "32px",
				}}
			/>
		);
	} else if (client_company) {
		return (
			<Select
				mode="multiple"
				placeholder="Select Client"
				value={c === "client_company_completed" ? completed : selectedItems}
				onChange={c === "client_company_completed" ? handleselect_completed : handleselect}
				style={{
					width: "100%",
					margin: "0px 10px",
					minHeight: "32px",
				}}
				options={client_company?.map((item) => ({
					value: item.id,
					label: item.company_name,
				}))}
				filterOption={(inputValue, option) =>
					option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
				}
				open={
					c === "client_company_completed"
						? clientCompletedDropdownOpen
						: clientDropdownOpen
				}
				onDropdownVisibleChange={(visible) => {
					if (c === "client_company_completed") {
						setClientCompletedDropdownOpen(visible);
					} else {
						setClientDropdownOpen(visible);
					}
				}}
			/>
		);
	} else if (c === "jobid_filter") {
		return (
			<Select
				mode="tags"
				placeholder="Job Card No.or Serial No."
				value={jobIds}
				onChange={(values) => {
					// Accept both numeric (e.g., "123") and alphanumeric (e.g., "123A") serial numbers
					const uniqueJobIds = [
						...new Set(values.map((v) => String(v).trim()).filter((v) => v)),
					];
					setJobIds(uniqueJobIds);
					dispatch(jobCard_page(1));
					dispatch(Jobid_filter(arrayToQueryParam("jobid", uniqueJobIds)));
				}}
				tokenSeparators={[","]}
				style={{
					width: "100%",
					margin: "0px 10px",
					minHeight: "32px",
				}}
			/>
		);
		} else if (c === "jobid_filter_completed") {
	return (
		<Select
		mode="tags"
		placeholder="Enter Job Card No. (use comma)"
		value={jobIdsCompleted}
		onChange={(values) => {
			// Accept both numeric (e.g., "123") and alphanumeric (e.g., "123A") serial numbers
			const uniqueJobIds = [
			...new Set(values.map((v) => String(v).trim()).filter((v) => v)),
			];
			setJobIdsCompleted(uniqueJobIds);
			dispatch(jobCard_pageComplete(1));
			dispatch(Jobid_filter_completed(arrayToQueryParam("jobid", uniqueJobIds)));
		}}
		tokenSeparators={[","]}
		style={{
			width: "100%",
			margin: "0px 10px",
			minHeight: "32px",
		}}
		/>
	);
	} else if (c === "embridary_placement_front_filter_completed") {
		const onSearch = (value) => {
			const v = (value || "").trim();
			dispatch(jobCard_pageComplete(1));
			dispatch(Embridary_placement_front_filter_completed(v));
		};

		return (
			<Input.Search
				placeholder="Search Embroidary Placement Front"
				value={selectedEmbridaryFront}
				onChange={(e) => {
					const v = e.target.value;
					setSelectedEmbridaryFront(v);
					if (v === "") {
						dispatch(jobCard_pageComplete(1));
						dispatch(Embridary_placement_front_filter_completed(""));
					}
				}}
				onSearch={onSearch}
				allowClear
				style={{
					width: "100%",
					margin: "0px 10px",
					height: "32px",
				}}
			/>
		);
	} else if (c === "embridary_placement_front_filter") {
		const onSearchUnder = (value) => {
			const v = (value || "").trim();
			dispatch(jobCard_page(1));
			dispatch(Embridary_placement_front_filter(v));
		};

		return (
			<Input.Search
				placeholder="Search Embroidary Placement Front"
				value={selectedEmbridaryFrontUnder}
				onChange={(e) => {
					const v = e.target.value;
					setSelectedEmbridaryFrontUnder(v);
					if (v === "") {
						dispatch(jobCard_page(1));
						dispatch(Embridary_placement_front_filter(""));
					}
				}}
				onSearch={onSearchUnder}
				allowClear
				style={{
					width: "100%",
					margin: "0px 10px",
					height: "32px",
				}}
			/>
		);
	} else {
		// Stage filter (visible only to Admin and Designer)
		if (![ROLES.ADMIN, ROLES.DESIGN].includes(role)) {
			return null;
		}

		return (
			<div style={{ display: "flex", flexDirection: "column", width: "100%", margin: "0px 10px" }}>
				<Select
					mode="multiple"
					placeholder="Select Stage"
					value={stage}
					onChange={handleselect2}
					style={{
						width: "100%",
						minHeight: "32px",
					}}
					options={stageOptions?.map((item) => ({
						value: item,
						label: item,
					}))}
				/>
				{hasStageSelected && (
					<div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 4 }}>
						{stageCounts.map((stageCount) => (
							<div key={stageCount.stage} style={{ display: "flex", alignItems: "center", gap: 6 }}>
								<Badge
									count={stageCount.count}
									showZero
									style={{
										backgroundColor: "#52c41a",
									}}
								/>
								<span style={{ 
									fontSize: 12, 
									color: "#666",
									fontWeight: 500,
								}}>
									{stageCount.label} Jobcards
								</span>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}
};

export default MultidropDown;